import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  TextField,
  Typography,
  Link,
  CircularProgress,
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { useNotification } from '../../contexts/NotificationContext';

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const { showNotification } = useNotification();
  const [status, setStatus] = useState(null);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Ingrese un email válido')
        .required('El email es requerido'),
    }),
    onSubmit: async (values) => {
      try {
        const response = await forgotPassword(values.email);
        setStatus({
          type: 'success',
          message: response.message || 'Se han enviado instrucciones a tu correo electrónico',
        });
        showNotification('Se han enviado instrucciones a tu correo electrónico', 'success');
      } catch (error) {
        setStatus({
          type: 'error',
          message:
            error.response?.data?.message ||
            'Error al solicitar recuperación de contraseña',
        });
      }
    },
  });

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      padding={2}
    >
      <Card sx={{ maxWidth: 400, width: '100%' }}>
        <CardContent sx={{ padding: 4 }}>
          <Box textAlign="center" mb={3}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/logo.png`}
              alt="NeuroPsico Cusco"
              style={{ height: 80, marginBottom: 16 }}
            />
            <Typography variant="h4" component="h1" gutterBottom>
              Recuperar Contraseña
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ingresa tu correo electrónico y te enviaremos instrucciones para
              recuperar tu contraseña
            </Typography>
          </Box>

          {status && (
            <Alert severity={status.type} sx={{ mb: 3 }}>
              {status.message}
            </Alert>
          )}

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id="email"
              name="email"
              label="Correo electrónico"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              margin="normal"
            />

            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={formik.isSubmitting}
              sx={{ py: 1.5, mt: 3 }}
            >
              {formik.isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Enviar Instrucciones'
              )}
            </Button>

            <Box textAlign="center" mt={3}>
              <Link component={RouterLink} to="/login" variant="body2" color="primary">
                Volver a Iniciar Sesión
              </Link>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPassword;